import "./enterprise_view.css";
import TitlePages from "../../../core/components/title_pages/title_pages.jsx";
import { useEnterpriseViewModel } from "../view_model/enterprise_view_model.jsx";
import { enterpriseMapper } from "../utils/mapper/enterprise_mapper.jsx";

const EnterpriseView = () => {
    const { isLogoVisible, logoRefDesktop, logoRefTablet } = useEnterpriseViewModel();
    const { title, sectionTitle, description, banner } = enterpriseMapper;

    return (
        <div className="enterprise">
            <div className="container">
                <TitlePages title={title} />
                <div className="enterprise_description">
                    <div className="row">
                        <div className="col-6">
                            <p id="inovacao">{sectionTitle.line1}</p>
                            <p id="tecnologia">{sectionTitle.line2}</p>
                        </div>
                        <div className="col-6">
                            <p>{description}</p>
                        </div>
                    </div>
                </div>
                <div className="enterprise_banner">
                    <div className="row">
                        <div className="col-6">
                            <div className="title">
                                <p>{banner.title}</p>
                            </div>
                            <div className="line"></div>
                            <div className="description">
                                <p>{banner.description}</p>
                            </div>
                            <div className="members">
                                <div className="person_images">
                                    {banner.members.images.map((member) => (
                                        <img key={member.id} id={member.id} src={member.src} alt={member.alt} />
                                    ))}
                                </div>
                                <div>
                                    <p dangerouslySetInnerHTML={{ __html: banner.members.names.replace(' e ', '<br />e ') }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className={`enterprise_logo ${isLogoVisible ? 'visible' : ''}`} ref={logoRefDesktop}>
                                <img src={banner.logo.src} alt={banner.logo.alt} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="enterprise_banner_tablet">
                    <div className={`enterprise_logo ${isLogoVisible ? 'visible' : ''}`} ref={logoRefTablet}>
                        <img src={banner.logo.src} alt={banner.logo.alt} />
                    </div>
                    <div className="title">
                        <p>{banner.title}</p>
                    </div>
                    <div className="line"></div>
                    <div className="description">
                        <p>{banner.description}</p>
                    </div>
                    <div className="members">
                        <div className="person_images">
                            {banner.members.images.map((member) => (
                                <img key={member.id} id={member.id} src={member.src} alt={member.alt} />
                            ))}
                        </div>
                        <div>
                            <p dangerouslySetInnerHTML={{ __html: banner.members.names.replace(' e ', '<br />e ') }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnterpriseView;
